// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"11e9f54a","158":"8b65ab33","172":"d1b3291d","272":"e1aec48e","432":"7558cbf7","532":"91b06187","784":"542760e2"}[chunkId] + ".chunk.js";
};